import React, { useEffect, useMemo } from 'react';
import { useState } from "react";
import PropTypes from "prop-types"
import classNames from 'classnames';
import styles from "./PaymentPage.module.css";
import { Button, InputBox, SelectBox } from "@cpnw/ui";
import { AccountContainer } from '../../hooks/useAccount'
import { use } from 'react';
import environment from "environment";

export default function PaymentPage({ }) {
  const { meData } = AccountContainer.useContainer();

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://secure.glacierpaygateway.com/token/CollectCheckout.js";
    script.setAttribute("data-checkout-key", environment.glacierCollectCheckoutKey);
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const pending = useMemo(() => {
    if (!meData) return {};
    if (!meData.pendingTransactions || meData.pendingTransactions.length === 0) return {};
    return meData.pendingTransactions[0];
  }, [meData]);

  return (
    <>
      <div className={styles.PaymentPageContainer}>
        <div className={styles.title}>You have an outstanding balance that needs to be resolved before continuing using the system.</div>
        <div className={styles.instructions}>Please click the Checkout button to make payment (you will be redirected to a secure checkout page).</div>

        <div className={styles.pendingTransaction}>
          <div className={styles.transactionDetails}>
            {/* <div className={styles.transactionId}>Charge ID: {pending.Id}</div> */}
            {pending.ProductName && <div className={styles.productName}>Title: {pending.ProductName ? pending.ProductName : 'N/A'}</div>}
            {/* <div className={styles.transactionSKU}>
              SKU: {pending.SKU ? pending.SKU : 'N/A'}
            </div> */}
            {pending.Description && <div className={styles.productDescription}>Description: {pending.Description ? pending.Description : 'N/A'}</div>}
            {pending.Amount && <div className={styles.transactionAmount}>Amount: {pending.Amount ? `$${pending.Amount}` : 'N/A'}</div>}
          </div>
        </div>

        <button className={styles.checkoutButton} id="checkout-button" data-amount="1000" data-currency="USD"
          onClick={() => {
            window.CollectCheckout.redirectToCheckout({
              lineItems: [
                {
                  sku: pending.SKU,
                  // sku: "Failed",
                  quantity: 1,
                }
              ],
              receipt: {
                showReceipt: true,
                redirectToSuccessUrl: true,
                sendToCustomer: true
              },
              successUrl: `${environment.dashboardUrl}/Account/Receipt?checkout_id=(TRANSACTION_ID)&order_id=${pending.Id}`,
              cancelUrl: `${environment.dashboardUrl}/Account/Payment`
            }).then((error) => {
              console.log(error);
            });
          }}>
          Checkout
        </button>
      </div>
    </>
  );
};